import { isEditingBuilderDoc } from '~/../components/builder/editor/helpers'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['themeOption', 'themeGroup']
  static values = { setting: String }

  connect() {
    this.settingValue = this.settingValue || 'theme'
    // Another switcher on the page (another menu) changed it: show the same choice here.
    this.onOtherChange = () => this.updateSelected()
    document.addEventListener('theme-switcher:changed', this.onOtherChange)
  }

  disconnect() {
    document.removeEventListener('theme-switcher:changed', this.onOtherChange)
  }

  // Do this when option target first connects cause we may be in a lazy dropdown
  themeOptionTargetConnected() {
    this.updateSelectedOnce()
  }

  // A segmented control (the admin user menu): its radios hold the choice.
  themeGroupTargetConnected() {
    this.updateSelectedOnce()
  }

  updateSelectedOnce() {
    if (this._selectedUpdated || isEditingBuilderDoc()) return
    this._selectedUpdated = true
    setTimeout(() => this.updateSelected(), 0)
  }

  changeTheme(e) {
    // A menu item carries data-theme; a segmented control's radio carries the value.
    const theme = e.currentTarget.dataset.theme || e.target.value
    const previousTheme =
      UserPreference.get(this.settingValue) ||
      localStorage.getItem(this.settingValue) ||
      window.defaultColorScheme ||
      'system'
    // updateSelected clicks the radio to show the saved choice; that is not a new choice.
    if (e.target.type === 'radio' && theme === previousTheme) return
    UserPreference.set(this.settingValue, theme)

    const tempStylesheet = document.createElement('style')
    tempStylesheet.innerHTML = '* { transition: none !important };'
    document.body.appendChild(tempStylesheet)
    this.updateSelected()
    void document.body.offsetWidth
    tempStylesheet.remove()
    if (theme !== previousTheme) {
      document.dispatchEvent(new CustomEvent('theme-switcher:changed'))
    }
  }

  updateSelected() {
    // This is defined in the head tag through _theme_from_user_preference.html.erb. It's inlined to prevent FOUC during initial page render.
    // It also dispatches 'theme-changed' when the resolved theme actually changes.
    window.setDarkClassBasedOnUserPreference?.()

    const theme =
      UserPreference.get(this.settingValue) ||
      localStorage.getItem(this.settingValue) ||
      window.defaultColorScheme ||
      'system'
    this.themeOptionTargets.forEach((option) => {
      const selected = option.dataset.theme === theme
      option
        .querySelector('.js-theme-active-icon')
        .classList.toggle('is-active', selected)
      // A segmented control's buttons (the Coach account menu) say which one is on.
      if (option.tagName === 'BUTTON') option.setAttribute('aria-pressed', String(selected))
    })
    // Click, not .checked: the button group draws the pick on change.
    this.themeGroupTargets.forEach((group) => {
      const input = group.querySelector(`input[value="${theme}"]`)
      if (input && !input.checked) input.click()
    })
  }
}
